import React from 'react'
import { useEnvValue } from '@morningtrain/react-helpers'
import classNames from 'classnames'
import { useForm } from '@morningtrain/react-resources'

export default function EditInventoryItemQuantity ({
  inventoryItemId,
  name,
  max = null,
  min = null,
  useAsInitial = null,
  className = null,
  disabled = false
}) {
  const form = useForm()

  const quantityKey = ['globals.inventory.order_items', inventoryItemId, name].join('.')
  const [quantity, setQuantity] = useEnvValue(quantityKey)

  const initialKey = ['globals.inventory.order_items', inventoryItemId, useAsInitial].join('.')
  const [initialValue] = useEnvValue(initialKey)

  const [internalValue, setInternalValue] = React.useState(quantity)

  React.useEffect(() => {
    if (quantity !== internalValue) {
      setQuantity(internalValue)
    }
  }, [internalValue])

  React.useEffect(() => {
    handleValueChange(quantity)
  }, [quantity])

  const handleValueChange = (newValue, isIncrementer = false) => {
    if (newValue === null) {
      setInternalValue(null)
      return
    }

    /// If incrementing for the first time and we have an initial value - set internal value using initial value
    if (isIncrementer === true && useAsInitial !== null && initialValue && internalValue === null) {
      setInternalValue(initialValue)
      return
    }

    newValue = parseInt(newValue)

    if (isNaN(newValue)) {
      newValue = 0
    }

    if (min !== null) {
      newValue = Math.max(min, newValue)
    }

    if (max !== null) {
      newValue = Math.min(max, newValue)
    }

    if (newValue !== internalValue) {
      form.setAsChanged()
      setInternalValue(newValue)
    }
  }

  const _className = classNames(
    'quantity-input',
    className
  )

  return (
    <div className={_className}>
      {
        !disabled ?
          (<div className='quantity-input-border'>
            <div onClick={() => handleValueChange(internalValue - 1, true)} className='quantity-input__btn-wrap'>
              <button type='button' disabled={disabled}>-</button>
            </div>

            <div className='quantity-input__text'>
              <input
                  value={internalValue !== null ? internalValue : 0}
                  onChange={e => handleValueChange(e.target.value)}
              />
            </div>

            <div onClick={() => handleValueChange(internalValue + 1, true)} className='quantity-input__btn-wrap'>
              <button type='button' disabled={disabled}>+</button>
            </div>
          </div>) : null
      }
    </div>
  )
}
